// NOTICE: This file was copied from the oppizi-shared repository, do
// not modify it here.

/**
 * @fileOverview
 * Defines a reducer that works with the `websockets` store state,
 * and maintains the general state of the websocket (i.e. not specific
 * to any particular domain like chat or live maps).
 */

const connected = (state, action) => {
  switch (action.type) {
    case 'WEBSOCKETS_CONNECT':
      return {
        ...state,
        connected: true,
      }
    case 'WEBSOCKETS_DISCONNECT':
      return {
        ...state,
        connected: false,
      }
    default:
      return state
  }
}

export default connected



// WEBPACK FOOTER //
// ./src/shared/websockets/ws-state-reducer.js